import { ArrowDown, ArrowUpRight } from "lucide-react";
import { openCalendly } from "../lib/calendly";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/3d59354d-0972-4474-8092-a9560caa3a16/images/6e26a6dfd8a5d5f9917a3be1d86fd4e442fd31c83d82f82213ffe39e242e12ca.png";

export default function Hero() {
    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative min-h-screen flex items-center overflow-hidden hero-vignette grain"
        >
            {/* Background image (right side, faded) */}
            <div
                aria-hidden="true"
                className="absolute inset-0 opacity-[0.35] mix-blend-screen"
                style={{
                    backgroundImage: `url(${HERO_BG})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center right",
                    backgroundRepeat: "no-repeat",
                    maskImage:
                        "linear-gradient(to right, transparent 0%, transparent 30%, black 100%)",
                    WebkitMaskImage:
                        "linear-gradient(to right, transparent 0%, transparent 30%, black 100%)",
                }}
            />
            <div className="absolute inset-0 bg-grid opacity-50 pointer-events-none" />

            {/* Subtle floating periwinkle accent */}
            <div
                aria-hidden="true"
                className="absolute -top-32 -left-32 w-[560px] h-[560px] rounded-full"
                style={{
                    background:
                        "radial-gradient(circle, rgba(91,58,120,0.45) 0%, transparent 70%)",
                    filter: "blur(40px)",
                }}
            />

            <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 pt-32 pb-24">
                <div className="grid grid-cols-12 gap-8">
                    <div className="col-span-12 lg:col-span-9">
                        <p
                            data-testid="hero-overline"
                            className="overline sr-fade-in flex items-center gap-3 mb-8"
                        >
                            <span className="lime-dot" />
                            Fractional & Interim CFO Services
                        </p>

                        <h1
                            data-testid="hero-headline"
                            className="font-heading text-white sr-fade-up text-[44px] sm:text-6xl md:text-7xl lg:text-[112px] leading-[0.95] tracking-tight"
                        >
                            Financial clarity
                            <br />
                            for the{" "}
                            <span className="italic font-light text-[#A3A8D8]">
                                road ahead
                            </span>
                            <span className="text-[#C6F432]">.</span>
                        </h1>

                        <p
                            data-testid="hero-subtext"
                            className="sr-fade-up delay-2 mt-10 max-w-2xl text-base md:text-lg leading-relaxed text-white/65 font-light"
                        >
                            Stout Road partners with founders and operators to build
                            the financial infrastructure that turns ambition into
                            durable growth — strategy, modeling, and board-grade
                            reporting, delivered on a fractional or interim basis.
                        </p>

                        <div className="sr-fade-up delay-3 mt-12 flex flex-wrap gap-4 items-center">
                            <button
                                data-testid="hero-primary-cta"
                                onClick={openCalendly}
                                className="btn-primary"
                            >
                                Book a 30-min Call
                                <ArrowUpRight size={14} />
                            </button>
                            <button
                                data-testid="hero-secondary-cta"
                                onClick={() => scrollTo("services")}
                                className="btn-ghost"
                            >
                                Explore Services
                            </button>
                        </div>
                    </div>
                </div>

                {/* Bottom meta strip */}
                <div className="sr-fade-up delay-5 absolute bottom-10 left-6 md:left-12 lg:left-20 right-6 md:right-12 lg:right-20 flex items-end justify-between">
                    <button
                        onClick={() => scrollTo("services")}
                        data-testid="hero-scroll-indicator"
                        className="flex items-center gap-3 text-white/50 hover:text-[#C6F432] transition-colors duration-300 group"
                    >
                        <span className="overline !tracking-[0.3em] text-white/50 group-hover:text-[#C6F432]">
                            Scroll
                        </span>
                        <span className="w-12 h-px bg-white/30 group-hover:bg-[#C6F432] transition-colors duration-300" />
                        <ArrowDown
                            size={16}
                            className="animate-bounce group-hover:text-[#C6F432]"
                        />
                    </button>

                    <div className="hidden md:flex items-end gap-12 text-right">
                        <div>
                            <p className="font-heading text-3xl text-white">
                                Startups
                            </p>
                            <p className="text-xs uppercase tracking-[0.25em] text-white/40 mt-1">
                                Seed — Series C
                            </p>
                        </div>
                        <div>
                            <p className="font-heading text-3xl text-white">
                                Mid-Market
                            </p>
                            <p className="text-xs uppercase tracking-[0.25em] text-white/40 mt-1">
                                $5M — $250M Revenue
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
